
import { defineComponent, PropType } from 'vue';
import { CouponsWithImageUrl } from '@/lib/api/coupons.api';

export default defineComponent({
  props: {
    items: {
      type: Object as PropType<CouponsWithImageUrl[]>,
      required: false,
      default: null,
    },
  },
});
